import React, { useState, useEffect, useRef } from 'react';
import ContentRenderer from './ContentRenderer.jsx';
import SentientOrb from '../orb/SentientOrb.tsx';

function StreamingText({ content, sources, visualCode, onComplete, streamingSpeed = 15 }) {
    const [displayedContent, setDisplayedContent] = useState('');
    const [isStreaming, setIsStreaming] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const orbRef = useRef(null);

    // Trigger orb pulse on each character chunk
    useEffect(() => {
        if (isStreaming && orbRef.current) {
            orbRef.current.triggerPulse();
        }
    }, [displayedContent, isStreaming]);

    useEffect(() => {
        if (!content || currentIndex >= content.length) {
            setIsStreaming(false);
            if (onComplete) {
                onComplete();
            }
            return;
        }

        // Stream content character by character (or chunk by chunk for faster display)
        const chunkSize = 3; // Show 3 characters at a time for smoother, faster streaming
        const timer = setTimeout(() => {
            const nextIndex = Math.min(currentIndex + chunkSize, content.length);
            setDisplayedContent(content.substring(0, nextIndex));
            setCurrentIndex(nextIndex);
        }, streamingSpeed);

        return () => clearTimeout(timer);
    }, [content, currentIndex, streamingSpeed, onComplete]);

    return (
        <div style={{ height: '100%', overflowY: 'auto' }}>
            <ContentRenderer
                content={displayedContent}
                sources={isStreaming ? null : sources}
                visualCode={visualCode}
            />
            {isStreaming && (
                <div style={{
                    display: 'inline-block',
                    width: '30px',
                    height: '30px',
                    verticalAlign: 'middle',
                    marginLeft: '8px'
                }}>
                    <SentientOrb
                        ref={orbRef}
                        action="talk"
                        color="#8478DC"
                        scale={0.3}
                    />
                </div>
            )}
        </div>
    );
}

export default StreamingText;
